export const POLLING_INTERVAL_MS = 60_000;
